import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import EISGNavbar from "@/components/eisg/Navbar";
import EISGFooter from "@/components/eisg/Footer";
import WhatsAppButton from "@/components/eisg/WhatsAppButton";

const EISGLayout = () => {
  const location = useLocation();
  React.useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [location.pathname]);
  return (
    <div className="min-h-screen flex flex-col bg-[#FAFAFA] text-[#0A192F] font-body">
      <EISGNavbar />
      <main className="flex-1 pt-24 sm:pt-28">
        <Outlet />
      </main>
      <EISGFooter />
      <WhatsAppButton />
    </div>
  );
};

export default EISGLayout;
